import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  backgroundColor: (p) => p.palette.grey[200],
  borderRadius: 1,
  padding: (p) => p.spacing(1, 1.5),
  alignItems: 'center',
};
